import { get, omit } from 'lodash';
import * as ReactBootstrap from 'react-bootstrap';
import React from 'react';
import { TBaseTag } from '../CustomTag/types';

const BootstrapTag: React.FC<{
  name?: string;
  tagProps: Partial<TBaseTag>;
  children: React.ReactNode;
}> = React.memo(({ name, tagProps, children }) => {
  const Tag = get(ReactBootstrap, name || 'unknown');
  if (!Tag || tagProps.excluded) return null;

  return <Tag {...omit(tagProps, 'excluded')}>{children}</Tag>;
});
BootstrapTag.displayName = 'BootstrapTag';
export default BootstrapTag;
